module.exports = __webpack_public_path__ + "static/media/coupon.52023624.svg";